import React from "react";
import DesktopNavbarBrand from "./DesktopNavbarBrand";
import DesktopNavbarNav from "./DesktopNavbarNav";
import DesktopNavbarAuth from "./DesktopNavbarAuth";

function DesktopNavbar({
  navigate,
  t,
  isLoggedIn,
  isAdmin,
  currentUserId,
  searchContainerRef,
  query,
  handleSearchChange,
  isSearching,
  showResults,
  searchResults,
  currentLang,
  isAuthLoading,
  profilePictureUrl,
  userName,
  handleGoToCreateBook,
  unreadCount,
  handleNotificationsClick,
  openLoginModal,
  openRegisterModal,
}) {
  return (
    <>
      {/* Десктопный навбар */}
      <nav className="hidden tablet:flex bg-[#191A1C] py-0 h-12">
        <div className="flex h-12 items-center justify-between px-6 desktop:px-12 w-full">
          <DesktopNavbarBrand navigate={navigate} />

          <DesktopNavbarNav
            navigate={navigate}
            t={t}
            isLoggedIn={isLoggedIn}
            isAdmin={isAdmin}
            currentUserId={currentUserId}
            searchContainerRef={searchContainerRef}
            query={query}
            handleSearchChange={handleSearchChange}
            isSearching={isSearching}
            showResults={showResults}
            searchResults={searchResults}
            currentLang={currentLang}
          />

          <DesktopNavbarAuth
            t={t}
            isLoggedIn={isLoggedIn}
            isAuthLoading={isAuthLoading}
            profilePictureUrl={profilePictureUrl}
            userName={userName}
            openRegisterModal={openRegisterModal}
            handleGoToCreateBook={handleGoToCreateBook}
            openLoginModal={openLoginModal}
            unreadCount={unreadCount}
            handleNotificationsClick={handleNotificationsClick}
          />
        </div>
      </nav>
    </>
  );
}

export default DesktopNavbar;
